<template>
  <div
    class="upload-multiple"
    :class="canUpload && saveInner && hasUnuploadedFiles ? 'w-100' : ''"
    @paste="handlePaste"
  >
    <div class="d-inline-flex titleType">
      <p :is="titleTag" :class="titleClass" v-if="title">{{ title }}</p>
      <button
        v-if="canUpload && saveInner && hasUnuploadedFiles"
        @click="updateImage"
        :disabled="!hasUnuploadedFiles"
        class="btn btn-success"
      >
        Lưu
      </button>
    </div>
    <div
      class="img-list"
      v-if="fileType === 'image' && canUpload"
      @dragover.prevent="dragOver"
      @dragleave.prevent="dragLeave"
      @drop.prevent="handleDrop"
      :class="{ 'drag-over': isDragging }"
    >
      <ul v-viewer class="m-0">
        <li class="p-1 item-img" v-for="(item, index) in fileUploads" :key="index">
          <a href="javascript:void(0)">
            <img :src="url(item) || item" />
          </a>
          <span v-if="canRemoveFile(item)" @click="removeFile(item.id)">
            <i class="bx bx-trash bx-sm"></i>
          </span>
        </li>
        <li class="box-add-img p-1">
          <div v-if="canUpload && fileUploads.length < maxFile" class="add-img">
            <span class="bx bx-plus text-center text-gray"></span>
            <input
              :id="`input-${uniqueKey}`"
              type="file"
              :ref="uniqueKey"
              :accept="accept"
              multiple
              @change="handleFileChange"
            />
          </div>
          <div class="upload-popup box-hover">
            <ul>
              <li class="w-100 border-bottom">
                <label class="w-100 mb-0 font-weight-500 font-size-12" :for="`input-${uniqueKey}`"
                  >Tải lên</label
                >
              </li>
              <li class="clickable-paste w-100 font-size-14 font-weight-500 pt-2">
                <div class="d-flex w-100 justify-content-between customer-footer">
                  <label class="w-50 mb-0 border-right p-2 text-center" for="inputFile">
                    <i class="bx bx-upload"></i>
                  </label>
                  <div class="w-50 text-center p-2" @click="triggerPaste">
                    <i class="bx bx-paste"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import { CommonService } from '../../services/common.service'
  // import cloneDeep from "lodash/cloneDeep";

  export default {
    name: 'UploadMultipleCSKH2',
    props: {
      isHidden: {
        type: Boolean,
        default: false,
      },
      keyUrl: {
        type: String,
        default: 'url',
      },
      fileType: {
        type: String,
        default: 'image',
      },
      titleTag: {
        type: String,
        default: 'p',
      },
      titleClass: {
        type: String,
        default: '',
      },
      title: {
        type: String,
      },
      accept: {
        type: String,
        default: 'image/jpeg, image/png',
      },
      maxFile: {
        type: Number,
        default: 10,
      },
      // maxFileSize: {
      //   type: Number,
      //   // default: 20,
      //   default: () => Number((window._env_?.VUE_APP_MAX_FILE_SIZE ?? process.env.VUE_APP_MAX_FILE_SIZE) || 5)

      // },
      maxFileSize: {
        type: Number,
        default: () =>
          Number((window._env_?.VUE_APP_MAX_FILE_SIZE ?? process.env.VUE_APP_MAX_FILE_SIZE) || 50), // Mặc định 50MB
      },
      maxImageFileSize: {
        type: Number,
        default: () =>
          Number(
            (window._env_?.VUE_APP_MAX_IMAGE_FILE_SIZE ??
              process.env.VUE_APP_MAX_IMAGE_FILE_SIZE) ||
              5
          ), // Mặc định 5MB
      },
      uniqueKey: {
        type: String,
        default: () => uuidv4(),
      },
      canUpload: {
        type: Boolean,
        default: true,
      },
      saveInner: {
        type: Boolean,
        default: false,
      },
      canRemoveOldFile: {
        type: Boolean,
        default: true,
      },
      uploadToApi: {
        type: Boolean,
        default: false,
      },
      uploadApi: {
        type: Function,
        default: null,
      },
      imagesPreview: {
        type: Array,
        // default: [],
        default: () => [],
      },
    },
    data() {
      return {
        // fileUploads: [],
        error: null,
        isDragging: false,
        isMouseInPopup: false,
      }
    },
    computed: {
      hasUnuploadedFiles() {
        return this.fileUploads.some(file => !file.uploaded)
      },
      acceptedTypes() {
        return this.accept.split(',').map(type => type.trim())
      },
      fileUploads() {
        return this.imagesPreview
        // return this.imagesPreview.map(item => ({ url: item }));
      },
    },
    // watch: {
    //   fileUploads: {
    //     handler(val) {
    //       console.log("val", val);
    //     },
    //     deep: true,
    //   },
    // },

    methods: {
      setData(data) {
        // const newFiles = data.filter(
        //   (newFile) =>
        //     !this.fileUploads.some(
        //       (existingFile) => existingFile.id === newFile.id
        //     )
        // );
        // this.fileUploads.push(...newFiles);
        const newFiles = data.map(item => ({
          [this.keyUrl]: item.url,
          location: item.location,
          type: item.type || this.uniqueKey,
          uploaded: item.uploaded || true,
        }))

        this.fileUploads = newFiles
        this.$emit('change', this.getData(), 'add')
      },
      getData() {
        return [...this.fileUploads]
      },

      async saveData() {
        const files = this.fileUploads
        const explanationImage = []
        for (const file of files) {
          if (typeof file === 'string') {
            explanationImage.push(file)
          } else {
            if (file.file && !file.uploaded) {
              const resImg = await this.sendFile(file)
              explanationImage.push(resImg.urlFile)
            }
          }
        }
        return explanationImage
      },

      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },

      removeFile(id) {
        const index = this.fileUploads.findIndex(s => s.id === id)
        if (index !== -1) {
          this.fileUploads.splice(index, 1)
          this.$emit('change', this.getData(), 'remove')
        }
        this.error = null
      },
      url(item) {
        return item?.[this.keyUrl]
      },

      canRemoveFile(file) {
        return this.canRemoveOldFile || !file.uploaded
      },
      // validateFile(file) {
      //   if (this.fileUploads.length >= this.maxFile) {
      //     this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFile} file`);
      //     return false;
      //   }
      //   if (this.accept !== "*/*") {
      //     const formatUpload = this.accept.split(",").map((s) => s.trim());
      //     if (
      //       !formatUpload.some((type) =>
      //         file.type.startsWith(type.replace("/*", ""))
      //       )
      //     ) {
      //       this.showFailMx("Định dạng file của bạn không hợp lệ");
      //       return false;
      //     }
      //   }
      //   if (file.size > this.maxFileSize * 1024 * 1024) {
      //     this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFileSize}MB`);
      //     return false;
      //   }
      //   return true;
      // },

      isImageFile(file) {
        return file.type.startsWith('image/')
      },

      getMaxFileSize(file) {
        return this.isImageFile(file) ? this.maxImageFileSize : this.maxFileSize
      },
      validateFile(file) {
        if (!this.singleFile && this.fileUploads.length >= this.maxFile) {
          this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFile} file`)
          return false
        }

        // Check định dạng file
        if (this.accept !== '*/*') {
          const formatUpload = this.accept.split(',').map(s => s.trim())
          if (!formatUpload.some(type => file.type.startsWith(type.replace('/*', '')))) {
            this.showFailMx('Định dạng file của bạn không hợp lệ')
            return false
          }
        }

        // Check dung lượng với giới hạn khác nhau cho ảnh và file thông thường
        const maxSize = this.getMaxFileSize(file)
        if (file.size > maxSize * 1024 * 1024) {
          const fileType = this.isImageFile(file) ? 'ảnh' : 'file'
          this.showFailMx(`Dung lượng ${fileType} vượt quá giới hạn cho phép (${maxSize}MB)`)
          return false
        }

        return true
      },

      async uploadFile(file) {
        if (!this.validateFile(file)) return null

        const existingFile = this.fileUploads.find(
          f => f.name === file.name && f.size === file.size
        )
        if (existingFile) {
          this.showFailMx(`File ${file.name} đã tồn tại và sẽ không được upload lại.`)
          return existingFile
        }

        const newFile = {
          id: uuidv4(),
          name: file.name || `pasted-image-${Date.now()}.${file.type.split('/')[1]}`,
          size: file.size,
          [this.keyUrl]: URL.createObjectURL(file),
          file,
          type: this.uniqueKey,
          uploaded: false,
          location: '',
        }

        if (this.uploadToApi && this.uploadApi) {
          try {
            const result = await this.uploadApi(file)
            newFile[this.keyUrl] = result.url
            newFile.location = result.location || ''
            newFile.uploaded = true
          } catch (error) {
            this.showFailMx('Upload thất bại. Vui lòng thử lại.')
            return null
          }
        }

        this.fileUploads.push(newFile)

        this.$emit('change', this.getData(), 'add')
        this.$emit('syncFile', this.getData(), this.uniqueKey)

        this.error = null
        return newFile
      },
      dragOver(event) {
        this.isDragging = true
      },
      dragLeave(event) {
        this.isDragging = false
      },
      handleDrop(event) {
        this.isDragging = false
        const files = event.dataTransfer.files
        this.processFiles(files)
      },
      handleFileChange(event) {
        const files = event.target.files
        this.processFiles(files)
      },
      isAcceptedFileType(file) {
        if (this.accept === '*/*') return true
        return this.acceptedTypes.some(type => {
          if (type.endsWith('/*')) {
            return file.type.startsWith(type.replace('/*', ''))
          }
          return file.type === type
        })
      },

      triggerPaste() {
        navigator.clipboard
          .read()
          .then(clipboardItems => {
            for (const clipboardItem of clipboardItems) {
              for (const type of clipboardItem.types) {
                if (type.startsWith('image/')) {
                  clipboardItem.getType(type).then(blob => {
                    this.processFiles([blob])
                  })
                  return
                }
              }
            }
            this.showFailMx('Không tìm thấy ảnh trong clipboard')
          })
          .catch(err => {
            console.error('Lỗi khi đọc clipboard:', err)
            this.showFailMx('Không thể đọc clipboard. Vui lòng thử lại.')
          })
      },
      handlePaste(event) {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items
        for (const item of items) {
          if (item.type.indexOf('image') !== -1) {
            const blob = item.getAsFile()
            if (this.isAcceptedFileType(blob)) {
              this.processFiles([blob])
            } else {
              this.showFailMx(`Loại file ${blob.type} không được chấp nhận.`)
            }
            return
          }
        }
        this.showFailMx('Không tìm thấy ảnh trong clipboard')
      },
      async processFiles(files) {
        if (files.length > 0) {
          for (const file of files) {
            await this.uploadFile(file)
          }
          this.$refs[this.uniqueKey].value = null
          this.$emit('filesSelected', this.getData())
        }
      },

      async updateImage() {
        if (!this.uploadToApi) {
          this.fileUploads.forEach(file => {
            file.uploaded = true
            file.location = file.location || ''
          })
        } else if (this.uploadApi) {
          const filesToUpload = this.fileUploads.filter(file => !file.uploaded)
          for (const file of filesToUpload) {
            try {
              const result = await this.uploadApi(file.file)
              file[this.keyUrl] = result.url
              file.location = result.location || ''
              file.uploaded = true
            } catch (error) {
              this.showFailMx(`Upload thất bại cho file ${file.name}. Vui lòng thử lại.`)
            }
          }
        }
        this.$emit('updateImage', this.getData(), this.uniqueKey)
      },
    },

    // async processFiles(files) {
    //   if (files.length > 0) {
    //     for (const file of files) {
    //       await this.uploadFile(file);
    //     }
    //     this.$refs[this.uniqueKey].value = null;
    //     this.$emit("filesSelected", this.getData());
    //   }
    // },
    // async updateImage() {
    //   if (!this.uploadToApi) {
    //     // Nếu không upload lên API, chỉ đánh dấu tất cả các file là đã upload
    //     this.fileUploads.forEach((file) => (file.uploaded = true));
    //   } else if (this.uploadApi) {
    //     const filesToUpload = this.fileUploads.filter((file) => !file.uploaded);
    //     for (const file of filesToUpload) {
    //       try {
    //         const result = await this.uploadApi(file.file);
    //         file[this.keyUrl] = result.url; // Giả sử API trả về URL của file đã upload
    //         file.uploaded = true;
    //       } catch (error) {
    //         console.error("Upload failed:", error);
    //         this.showFailMx(
    //           `Upload thất bại cho file ${file.name}. Vui lòng thử lại.`
    //         );
    //       }
    //     }
    //   }
    //   this.$emit("updateImage", this.getData(), this.uniqueKey);
    // },
  }
</script>

<style lang="scss" scoped>
  .upload-multiple {
    .error {
      color: red;
      font-size: 12px;
      font-weight: 400;
    }
    .titleType {
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding-bottom: 5px;
    }
    .img-list {
      position: relative;
      ul {
        .item-img {
          width: 108px;
          a {
            border: 2px solid #dcdcdc;
          }
          span {
            cursor: pointer;
            display: none;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
          }
          &:hover span {
            display: block;
          }
        }
      }
    }
    .img-list.drag-over {
      border-color: #007bff;
      background-color: rgba(0, 123, 255, 0.1);
    }
    .add-img {
      position: relative;
      cursor: pointer;
      border: 2px dashed #dcdcdc;
    }
    .add-img:hover {
      border: 2px dashed #007bff;
    }
    .add-img span {
      position: absolute;
      top: 37%;
      right: 28%;
      font-size: 30px;
      font-weight: 400;
      color: #dcdcdc;
    }
    .add-img span:hover {
      color: #007bff;
    }
    .add-img input[type='file'] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    .box-add-img {
      position: relative;
      .box-hover {
        display: none;
      }
      &:hover .box-hover {
        display: block;
      }
    }
    .upload-popup {
      position: absolute;
      height: 150px;
      border: 2px dashed #dcdcdc;
      top: 0;
      left: 0;
      margin-left: 1px;
      width: 100%;
      border: 2px dashed #007bff;
      background-color: #fff;
      border-radius: 10px;
      z-index: 150;
      &hover {
        background-color: #007bff;
      }
      ul {
        li {
          padding: 0 !important;
          label {
            cursor: pointer;
            height: 110px;
            padding-top: 55px;
          }

          width: revert;
        }
        .customer-footer {
          padding: 0;
          label {
            height: fit-content;
            padding-top: 0;
          }
          width: revert;
        }
      }
    }

    .upload-popup ul {
      list-style-type: none;
      padding-left: 0;
    }
    .upload-popup ul li {
      height: revert;
      padding: 6px;
      cursor: pointer;
    }
    .upload-popup li {
      font-weight: 600;
      font-size: 0.9em;
    }
  }
</style>
